import { Button, Space, Tag } from "antd";

export interface EditModeActionsProps {
  readonly editor: {
    readonly saving: boolean;
    readonly saveError: boolean;
    readonly cancelEditing: () => void;
    readonly save: () => void;
  };
}

/**
 * The shared Save / Cancel (+ "Save failed" indicator) block shown while an entity card is in edit
 * mode. Centralized so every user-centric view that uses `useEntityEditor` renders the identical
 * edit-mode controls (the view-mode actions differ per surface and stay local).
 */
function EditModeActions({ editor }: EditModeActionsProps) {
  return (
    <Space>
      {editor.saveError && <Tag color="red">Save failed</Tag>}
      <Button onClick={editor.cancelEditing} disabled={editor.saving}>
        Cancel
      </Button>
      <Button type="primary" loading={editor.saving} onClick={editor.save}>
        Save
      </Button>
    </Space>
  );
}

export default EditModeActions;
